/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HttpPolicySetModule
 */

import { MessageItem }
    from 'ajs/modules/data-model/factories/message-item.factory';

import { RepeatedMessageItem }
    from 'ajs/modules/data-model/factories/repeated-message-item.factory';

import {
    withEditChildMessageItemMixin,
} from 'ajs/modules/data-model/mixins/with-edit-child-message-item.mixin';

import { IHTTPResponsePolicy } from 'generated-types';
import { HTTPResponsePolicy } from 'object-types';
import { HTTPResponseRuleConfigItem } from './http-response-rule.config-item.factory';

type THTTPResponsePolicyPartial = Omit<IHTTPResponsePolicy, 'rules'>;

interface IHTTPResponsePolicyConfig extends THTTPResponsePolicyPartial {
    rules?: RepeatedMessageItem<HTTPResponseRuleConfigItem>;
}

/**
 * @description
 *
 *   HTTPPolicySet Response Policy Message Item.
 *
 * @author Abhinesh Gour, Umesh Chovatiya
 */
export class HTTPResponsePolicyConfigItem extends
    withEditChildMessageItemMixin(MessageItem)<IHTTPResponsePolicyConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: HTTPResponsePolicy,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Opens Create HTTP Response Rule Modal.
     */
    public addResponseRule(): void {
        this.addChildMessageItem({
            field: 'rules',
            modalBindings: {
                isEditing: false,
            },
        });
    }

    /**
     * Getter for HTTP Response Rule ConfigItem.
     */
    public get rules(): RepeatedMessageItem<HTTPResponseRuleConfigItem> {
        return this.config.rules;
    }

    /**
     * Merge match field as null if match does not exist in Response item for edit.
     */
    public editResponseRuleModal(messageItem: HTTPResponseRuleConfigItem): void {
        if (!messageItem.config.match) {
            messageItem.mergeConfig({ match: null });
        }

        this.editChildMessageItem({
            field: 'rules',
            messageItem,
            modalBindings: {
                isEditing: true,
            },
        });
    }
}
